import { useUserStore } from '@/config/store/userStore'
import { isModuleActive } from '@/services/application'
import { RightsReadWriteUtils } from '@bc-library/interface'
import {
  hasAnyHrSettingsAccess,
  hasHrSettingAccess,
  type HrSettingAccessKey,
} from '@/services/hr/settingsAccess'

const moduleId = 1

const canUserAccessModule = (user) => {
  const isFirmAccess = isModuleActive(user.firm, moduleId)
  return isFirmAccess && user.profile.modules.hr.isAccess
}
export const guardResourceProfile = (to) => {
  const userStore = useUserStore()
  const user = userStore.user
  if (!user)
    return { name: 'Login' }
  if (to.params.resourceId === user._id)
    return true
  return user.profile?.modules?.hr?.resourceProfileAccess || { name: 'Home' }
}

export const guardHrAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const accessModule = canUserAccessModule(user)
  return accessModule || { name: 'Home' }
}

export const guardHrAlumniAccess = () => {
    const userStore = useUserStore()
    const user = userStore.user
    return user.profile.modules?.hr?.alumniAccess ? user.profile.modules.hr.alumniAccess : { name: 'Home' }
}

export const guardEmployeeOnboardingAccess = () => {
    const userStore = useUserStore()
    const user = userStore.user
    return user.profile.modules?.hr?.onboardingAccess ? user.profile.modules.hr.onboardingAccess : { name: 'Home' }
}

// Campaigns lean on the e-signature add-on: without it the firm has no signature template at all.
export const guardSignatureCampaignAccess = () => {
    const userStore = useUserStore()
    const user = userStore.user
    if (!user.firm?.eSignature)
      return { name: 'Home' }
    return user.profile.modules?.hr?.signatureCampaignAccess ? true : { name: 'Home' }
}

export const guardHrStatsAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return user.profile.modules.hr.statsAccess ? user.profile.modules.hr.statsAccess : { name: 'Home' }
}

export const guardHrHeadcountAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return user.profile.modules.hr?.headcountAccess ? true : { name: 'Home' }
}

export const guardHrCanValidateHeadcount = () => {
  const userStore = useUserStore()
  return !!userStore.user?.profile?.modules?.hr?.headcountValidationAccess
}

export const guardHrCreateResource = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return user.profile.modules.hr.createResourceAccess ? user.profile.modules.hr.createResourceAccess : { name: 'Home' }
}


export const guardHrCanPromote = () => {
  const userStore = useUserStore()
  const userProfile = userStore.user.profile
  const userProfileAccessJobPath = userProfile.modules.hr?.accessJobPath
  return RightsReadWriteUtils.canWrite(userProfileAccessJobPath) 
}

export const guardSettingsAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return hasAnyHrSettingsAccess(user.profile.modules.hr, !!user.firm?.eSignature) || { name: 'Home' }
}

export const guardHrSettingAccess = (key: HrSettingAccessKey) => {
  const userStore = useUserStore()
  const user = userStore.user
  return hasHrSettingAccess(user.profile.modules.hr, key) || { name: 'Home' }
}

export const guardHrCanSeeWages = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return user.profile.modules.hr?.wageAccess ? user.profile.modules.hr.wageAccess : { name: 'Home' }
}
